import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import NewLogo from '../smartevaccms.png';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import {app, auth} from './Firebase.js';
import { signInWithEmailAndPassword  } from "firebase/auth";
import React, { useState } from 'react';

function Login() {
  const navigate = useNavigate(); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [colour, setColour] = useState("white");
  const [attemptNumber, setattemptNumber] = useState(4);
  
  

  const handleRegister = (event) => {
    event.preventDefault();
    navigate('/register'); 
  };


  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/adminpage");
    } catch (err) {
      console.error("Invalid email or password. Please try again.");
      if (attemptNumber==1){
        navigate('/failedAttempts'); 
      }else{
        setColour("red");
        setattemptNumber(attemptNumber-1);
      }
    }
  };


  return (
    <Container className= "main-page-content">
      <Row className="justify-content-center">
        <Col xs={6} sm={6} md={6} lg={6}>
          <form onSubmit={handleLogin}>
          <div className="centered">
            <img src={NewLogo} width="200" height="160" alt="SmartEvac Logo" />
          </div>
            <p className="Title">Login</p>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <p>
              <span style={{ color: colour }}>Invalid Email or Password - Attempts remaining:   {attemptNumber}</span>
            </p>
            <button type="submit" className="login-button">Login</button>
          </form>
          <p className="SignUpIndicator">
            <span className="SignUpQuestion">New to SmartEvac?</span>
            <a href="#" onClick={handleRegister}>Join now</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
